import React from 'react';

export default React.createContext({
  orders: [],
  orderPay: [],
  panierVisible: false
});